import { render } from "./MovieGridItem.vue?vue&type=template&id=7f315396&ts=true"
import script from "./MovieGridItem.vue?vue&type=script&lang=ts"
export * from "./MovieGridItem.vue?vue&type=script&lang=ts"

import "./MovieGridItem.vue?vue&type=style&index=0&id=7f315396&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__